export function MesaLogo({ className = "h-10 w-10" }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt=""
      aria-hidden="true"
      className={className}
      style={{ objectFit: 'contain' }}
      draggable={false}
    />
  );
}
